'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
    this.getData();
  }

  getData() {
    this.$http.get('/api/monitors').then(res => {
      this.data = res.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete(`/api/monitors/${id}`).then(res => {
        this.getData();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/monitor/list/list.controller.js